export class Alarme {
    ativo: boolean;
    nome: string;
    titulo: string;
    tipoEvento: string;
    minimoVelocidade: number;
    maximoVelocidade: number;
    templateId : number;
    id: number;
}

export class BemAlarme {
    ativo: boolean;
    bemId: number;
    alarmeId: number;
    id: number;
}

export class CercaAlarme {
    ativo: boolean;
    alarmeId: number;
    cercaProjetoId: number;
    id: number;
}

export class EmailAlarme {
    ativo: boolean;
    email: string;
    alarmeId: number;
    id: number;
}

export class TemplateAlarme {
    ativo: boolean;
    nome: string;
    conteudo: string;
    id: number;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/alarmes/shared/alarme.model.ts
 **/